/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Platform_IosInputs */

const en_pricing_platform_ios = /** @type {(inputs: Pricing_Platform_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const es_pricing_platform_ios = /** @type {(inputs: Pricing_Platform_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

/**
* | output |
* | --- |
* | "iOS" |
*
* @param {Pricing_Platform_IosInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_platform_ios = /** @type {((inputs?: Pricing_Platform_IosInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Platform_IosInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_platform_ios(inputs)
	return en_pricing_platform_ios(inputs)
});